import { render, staticRenderFns } from "./ModalTestResult.vue?vue&type=template&id=724ea333&scoped=true"
import script from "./ModalTestResult.vue?vue&type=script&lang=js"
export * from "./ModalTestResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ea333",
  null
  
)

export default component.exports